import React from 'react'
import './css/Navigation.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link, useNavigate } from "react-router-dom"
import { Button, IconButton, Tooltip } from '@mui/material'
import Logo from "../assets/Logo.svg"
import logo from '../assets/Icon.svg'
import dashboard from '../assets/menu-icons/new-icons/dashboard.svg'
import crm from '../assets/menu-icons/crm.svg'
import date from '../assets/menu-icons/new-icons/leaves.svg'
import chart from '../assets/menu-icons/new-icons/org-chart.svg'
import doc from '../assets/menu-icons/new-icons/other-documents.svg'
import screen from '../assets/menu-icons/screen.svg'
import setting from '../assets/menu-icons/settings.svg'
import gift from '../assets/menu-icons/new-icons/purchase-orders.svg'
import notification from '../assets/menu-icons/new-icons/notifications.svg'



const Navigation = () => {
    const navigate = useNavigate()

    return (
        <>
            {/* <div className="app-component-header">
            <div className="app-component-header__left">
                <div className="app-component-header__back">
                    <Tooltip title="Back to main panel">
                        <IconButton variant="contained" className='back-to-main'>
                            <a onClick={() => navigate("/")}>
                                <ArrowBackIcon/>
                            </a>
                        </IconButton>
                    </Tooltip>
                </div>
                <div className="app-component-header__logo">
                    <img style={{ cursor: "pointer" }} onClick={() => navigate("/")} src={Logo} alt="" />
                    <span>CRM</span>
                </div>
            </div>
            <ul className="app-component-header__menu">
                <li className="app-component-header__menuitem">
                    <Link to="/leads/leads-management">Lead Management</Link>
                </li>
                <li className="app-component-header__menuitem">
                    <Link to="/leads/leads-pipe-view">Leads</Link>
                </li>
                <li className="app-component-header__menuitem">
                    <Link to="/forms">Forms</Link>
                </li>
                <li className="app-component-header__menuitem">
                    <a href='https://support.vibhotech.com/' className='support-btn'>
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"/></svg> Support
                    </a>
                </li>
            </ul>
        </div> */}
            {/* <div className='app-header-bar'>
                <div className='menu-bar'>
                    <ul className="pinkify-aid">
                        <li>
                            <div onClick={() => window.location.href = "/"}>
                                <img src={logo} />
                            </div>
                        </li>
                        <ul className='dashboard'>
                            <li>
                                <Link to="#">
                                    <img src={dashboard} />
                                </Link>
                            </li>
                            <li>
                                <Link to="/">
                                    <img src={crm} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={date} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={chart} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={doc} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={screen} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={setting} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={date} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={chart} />
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <img src={doc} />
                                </Link>
                            </li>
                        </ul>
                    </ul>
                    <ul className='menu-item-2'>
                        <li>
                            <Link to=''>
                                <img src={gift} />
                            </Link>
                        </li>
                        <li>
                            <Link to=''>
                                <img src={notification} />
                            </Link>
                        </li>
                        <li>
                            <Link to=''>
                                <span>AK</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div> */}
        </>
    )
}

export default Navigation
